import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { take } from 'rxjs';
import { map } from 'rxjs/operators';

import { filterBoolean } from '@recruitee/common';
import type {
  RecentNavigationSnapshot,
  RequisitionVisitedSnapshot,
} from '@recruitee/dashboard-types';
import { ResourceKind } from '@recruitee/dashboard-types';
import { RequisitionsSelectors } from '@recruitee/requisitions-data';
import type { Requisition } from '@recruitee/requisitions-types';

const mapToRecentNavigationSnapshot = (requisition: Requisition): RequisitionVisitedSnapshot => {
  const { id, title } = requisition;
  return { id, name: title, kind: ResourceKind.Requisition };
};

export const requisitionSnapshotResolver = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<RecentNavigationSnapshot> => {
  const store = inject(Store);

  return store
    .select(RequisitionsSelectors.byId(route.params.id))
    .pipe(filterBoolean, take(1), map(mapToRecentNavigationSnapshot));
};
